import { request } from './http';

export async function getVerificationAttachments(verificationId) {
    return request(`/verifications/audits/${verificationId}/attachments`);
  }

export async function addVerificationAttachment(verificationId, { Filename, FileContainer, OriginalFilename }) {
    return request(`/verifications/audits/${verificationId}/attachments`, {
      method: 'POST',
      body: JSON.stringify({ Filename, FileContainer, OriginalFilename: OriginalFilename || null }),
    });
  }

export async function deleteVerificationAttachment(verificationId, attachmentId) {
    return request(`/verifications/audits/${verificationId}/attachments/${attachmentId}`, {
      method: 'DELETE',
    });
  }

export const auditAttachmentsApi = {
  getVerificationAttachments,
  addVerificationAttachment,
  deleteVerificationAttachment,
};

